import { ReactElement, useState } from 'react';

import SkillList from './components/List.Skill';
import Button from 'components/Button/ButtonV2';
import AddSkillModal from './components/Modal.AddSkill';
import DebouncedInput from './components/DebouncedInput';

export default function SkillViewPage(): ReactElement {
  const [open, setOpen] = useState<boolean>(false);

  const [keyword, setKeyword] = useState<string>('');

  return (
    <>
      <div className='pt-8 px-6'>
        <div className='flex justify-between items-center pb-8'>
          <span className='font-poppins font-semibold text-xl'>Skills</span>
          <Button
            onClick={() => setOpen(true)}
            className='font-poppins font-semibold text-sm leading-4 '
          >
            Add a new skill
          </Button>
        </div>

        <div className='mb-4'>
          <DebouncedInput
            placeholder='Search through our job titles, skills and industries we support'
            value={keyword}
            onChange={setKeyword}
          />
        </div>

        <SkillList showRole keyword={keyword} />

        <AddSkillModal open={open} setOpen={setOpen} />
      </div>
    </>
  );
}
